import React from "react";
import { ArrowUpRight } from "lucide-react";
import { services } from "../mock";

const Services = () => {
  return (
    <section id="services" className="py-20 md:py-28 bg-[#f6f9f3]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm font-bold uppercase tracking-widest text-[#5aa83a]">
            What we offer
          </span>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-[#123c74]">
            NDIS services made simple &amp; caring
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Flexible, person-centred supports designed around your goals, your
            routine and the things that matter most to you.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => {
            const Icon = service.icon;
            return (
              <div
                key={service.title}
                className="group bg-white rounded-2xl p-7 shadow-sm hover:shadow-xl border border-slate-50 transition-all duration-300 hover:-translate-y-1.5"
              >
                <div className="h-14 w-14 rounded-2xl flex items-center justify-center bg-[#eef6e8] group-hover:bg-[#5aa83a] transition-colors duration-300">
                  <Icon className="h-7 w-7 text-[#5aa83a] group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="mt-5 text-lg font-bold text-[#123c74]">
                  {service.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                  {service.description}
                </p>
                <a
                  href="#enquire"
                  className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#5aa83a] opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                >
                  Learn more <ArrowUpRight className="h-4 w-4" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
